import { TriggerDTO } from '@peartherapeutics/hylia-api-client';
import React from 'react';
import FlipMove from 'react-flip-move';
import { SNAPSHOT_TEST } from 'utils/constants';

import styles from './styles.module.scss';

export interface IProps {
  triggers: TriggerDTO[];
}

const Bar = ({ triggers = [] }: IProps) => {
  const barContents = triggers.map((trigger) => (
    <div
      key={trigger.type}
      className={styles.bar}
      data-testid="trigger-chart-bar"
    >
      <div className={styles.title}>{trigger.type}</div>
      <div
        className={styles.progress}
        style={{
          opacity: trigger.averageIntensity / 10,
          width: `${trigger.averageIntensity * 24}px`,
          marginRight: `${trigger.averageIntensity !== 0 ? '4px' : 0}`,
        }}
      />
      <div
        className={styles.percentage}
        data-testid={`trigger-value-${trigger.type
          .toLocaleLowerCase()
          .replace(/ .*/, '')}`}
      >
        {trigger.averageIntensity ? trigger.averageIntensity.toFixed(1) : '0'}
      </div>
    </div>
  ));

  /** Flag turns off animations to enable stable snapshot testing */
  return SNAPSHOT_TEST ? (
    <div>{barContents}</div>
  ) : (
    <FlipMove>{barContents}</FlipMove>
  );
};

export default Bar;
